import types from './types'
import { operator } from '../../api'

const updateAct = (centers) => ({
  centers,
  type: types.update,
})

/**
 * Get centers for operator loggin
 * @param {object} [params]
 * @param {boolean} [params.refresh]
 */
const get = (params = {}) => async (dispatch, getState) => {
  const { refresh = false } = params
  const { centers } = getState()

  try {
    if (centers?.isPending || refresh) {
      const { data } = await operator.operators.getCenters()

      dispatch(
        updateAct({
          brands: data?.brands || [],
          delegations: data?.delegations || []
        })
      )
    }

    return true
  } catch (error) {
    console.error('ct', error.message)
    return false
  }
}

export {
  updateAct,
  get,
}